import React, { useState } from 'react'
import { formatDateAndTimeWithoutLocal, formateDateWithTime } from '../../../utils/commonFunctions'
import { CalenderGreenIcon, CloseIcon } from '../../../assets/images'

type AppProps={
    data:any;
    history:any;
    handleSubmit : ()=>void;
    client_code:number | null
}

const ClientMeetUpHeader = ({data,history,handleSubmit,client_code}:AppProps) => {
    const sortBy = history?.location?.state?.sortBy;
    const searchData = history?.location?.state?.searchData;
    const meetingFilter= history?.location?.state?.meetingFilter

    const [modal,setModal]=useState<boolean>(false)

    const handleClientDetails=()=>{
        setModal(!modal)
      }

  return (
    <div className="bg_white">
        <div className="header">
          <div className="d-flex align-items-center">
            <div className="close" onClick={()=> {
                history.push({ pathname: "/lead-module/client-meet-up-check-list",
                state:{
                  sortBy,
                  searchData,
                  meetingFilter
                }
               });
            }}><img src={CloseIcon}/></div>
            <div className="ml-2 module_name">Client Meetup Checklist</div>
          </div>

          <div style={{color: "#dd4433"}}  onClick={handleSubmit}>SUBMIT</div>
        </div>

        <div
        className="line"
        ></div>

        <div className="meeting_date_time">
          <div className="client_name">
            {data?.clientOrOwnerName}
            <span className="client_code ml-2"> {`CC- ${client_code}`}</span>
          </div>

          <div className="view_client_details" onClick={handleClientDetails}>View Full Client Address</div>

          {
          modal ?
           <div>
               {data?.city} {data?.city ? "," : ""} {data?.state} {data?.state ? "," : ""} {data?.country}
           </div>
          : null
        }

          {/* //meeting date and time */}
          {data?.meetingDateOfTime ? <div className="mt-4">
            <div className="client_code">Meeting Date and Time</div>
            <div className="date ml-1"> <img src={CalenderGreenIcon} alt="" /> {formatDateAndTimeWithoutLocal(data?.meetingDateOfTime)}</div>
          </div> : null}
        </div>
      </div>
  )
}

export default ClientMeetUpHeader
